@if (isV2) {
  <div class="setting-row col">
    <div class="setting-label">
      {{ title || ("campaign.widget.sidebar.edit.appearance." + nameProp | translate) }}
      @if (currentDeviceView === WidgetDeviceViews.Mobile) {
        <app-toggle-device-button
          [isV2]="true"
          [isMobileFirst]="isMobileFirst"
          [mobileEqualsDesktop]="mobileEqualsDesktop"
          [setCurrentDeviceView]="currentDeviceView"
          [component]="component"
          (updateEditingDevice)="updateEditingDevice($event)"></app-toggle-device-button>
      }
    </div>
    <div
      class="multi-input-group"
      [class.brand-disabled]="isBrandSettingsValueApplied"
      [matTooltip]="isBrandSettingsValueApplied ? ('settings.customization.brand-settings.picker-tooltip' | translate) : ''"
      matTooltipShowDelay="300">
      <div class="multi-input-field" [matTooltip]="'generic.top' | translate" matTooltipShowDelay="300" [matTooltipDisabled]="isBrandSettingsValueApplied">
        <input type="number" min="0" [value]="v2Top" (input)="onV2InputChange('top', $event)" />
        <span class="multi-input-field-label">{{ "campaign.widget.sidebar.edit.appearance.border-width.top" | translate }}</span>
      </div>
      <div class="multi-input-field" [matTooltip]="'generic.right' | translate" matTooltipShowDelay="300" [matTooltipDisabled]="isBrandSettingsValueApplied">
        <input type="number" min="0" [value]="v2Right" (input)="onV2InputChange('right', $event)" />
        <span class="multi-input-field-label">{{ "campaign.widget.sidebar.edit.appearance.border-width.right" | translate }}</span>
      </div>
      <div class="multi-input-field" [matTooltip]="'generic.bottom' | translate" matTooltipShowDelay="300" [matTooltipDisabled]="isBrandSettingsValueApplied">
        <input type="number" min="0" [value]="v2Bottom" (input)="onV2InputChange('bottom', $event)" />
        <span class="multi-input-field-label">{{ "campaign.widget.sidebar.edit.appearance.border-width.bottom" | translate }}</span>
      </div>
      <div class="multi-input-field" [matTooltip]="'generic.left' | translate" matTooltipShowDelay="300" [matTooltipDisabled]="isBrandSettingsValueApplied">
        <input type="number" min="0" [value]="v2Left" (input)="onV2InputChange('left', $event)" />
        <span class="multi-input-field-label">{{ "campaign.widget.sidebar.edit.appearance.border-width.left" | translate }}</span>
      </div>
      <button
        type="button"
        class="multi-input-link-btn"
        [class.linked]="isLinked"
        (click)="toggleLinked()"
        [matTooltip]="
          (isLinked ? 'campaign.widget.sidebar.edit.appearance.multi-input.unlink' : 'campaign.widget.sidebar.edit.appearance.multi-input.link') | translate
        "
        matTooltipShowDelay="300"
        [matTooltipDisabled]="isBrandSettingsValueApplied">
        <mat-icon>{{ isLinked ? "link" : "link_off" }}</mat-icon>
      </button>
    </div>
  </div>
} @else {
  <div [class]="customClass" class="margin-padding-container">
    <div class="sidebar-edit-item-row">
      <mat-checkbox class="sidebar-edit-checkbox" [class.no-animation]="disableCheckboxAnimation" [(ngModel)]="propIsSet" (change)="toggleSetting()">
        <div class="sidebar-edit-item-text">{{ title || "campaign.widget.sidebar.edit.appearance." + nameProp | translate }}</div>
      </mat-checkbox>
    </div>
    @if (propIsSet) {
      <div class="sidebar-edit-item-row optional m-l-26" [ngClass]="{ mobile: currentDeviceView === WidgetDeviceViews.Mobile }" [class]="customClass">
        <div class="sidebar-edit-item-row-item">
          <div class="all-round-margin-btn all-round" [ngClass]="{ active: marginPaddingIsAllRound }" (click)="setMarginPaddingIsAllRound(true)"></div>
          <div class="all-round-margin-btn each-side" [ngClass]="{ active: !marginPaddingIsAllRound }" (click)="setMarginPaddingIsAllRound(false)">
            <div [ngClass]="shorthand.top && !marginPaddingIsAllRound ? 'top active' : 'top'"></div>
            <div [ngClass]="shorthand.right && !marginPaddingIsAllRound ? 'right active' : 'right'"></div>
            <div [ngClass]="shorthand.bottom && !marginPaddingIsAllRound ? 'bottom active' : 'bottom'"></div>
            <div [ngClass]="shorthand.left && !marginPaddingIsAllRound ? 'left active' : 'left'"></div>
          </div>
        </div>
        <div class="sidebar-edit-item-row-item">
          <app-toggle-device-button
            [isMobileFirst]="isMobileFirst"
            [mobileEqualsDesktop]="mobileEqualsDesktop"
            [setCurrentDeviceView]="currentDeviceView"
            [component]="component"
            (updateEditingDevice)="updateEditingDevice($event)"></app-toggle-device-button>
        </div>
        <div class="sidebar-edit-item-row-item">
          <div class="appearance-label">{{ "campaign.widget.sidebar.edit.appearance.margin-size" | translate }}</div>
          @if (marginPaddingIsAllRound) {
            <div class="single-margin-field">
              <mat-form-field class="margin-size-field small-input-field">
                <input matInput type="number" [(ngModel)]="currentMarginPadding.roundValue" (change)="updateAllRoundMarginSize()" />
              </mat-form-field>
            </div>
          }
          @if (!marginPaddingIsAllRound) {
            <div class="multi-margin-field" (focusout)="selectAllMargin(true)">
              <mat-form-field class="radius-size-field small-input-field">
                <input matInput type="number" [(ngModel)]="currentMarginPadding.top" (focus)="selectMargin('top')" (change)="updateSideMarginSizes()" />
              </mat-form-field>
              <mat-form-field class="radius-size-field small-input-field">
                <input matInput type="number" [(ngModel)]="currentMarginPadding.right" (focus)="selectMargin('right')" (change)="updateSideMarginSizes()" />
              </mat-form-field>
              <mat-form-field class="radius-size-field small-input-field">
                <input matInput type="number" [(ngModel)]="currentMarginPadding.bottom" (focus)="selectMargin('bottom')" (change)="updateSideMarginSizes()" />
              </mat-form-field>
              <mat-form-field class="radius-size-field small-input-field">
                <input matInput type="number" [(ngModel)]="currentMarginPadding.left" (focus)="selectMargin('left')" (change)="updateSideMarginSizes()" />
              </mat-form-field>
            </div>
          }
        </div>
        <div class="sidebar-edit-item-row-item">
          <div class="unit-label">px</div>
        </div>
      </div>
    }
  </div>

  <app-link-to-brand-variables
    [isBrandSettingsValueApplied]="isBrandSettingsValueApplied"
    [isDefaultValue]="propIsSet"
    [brandSettingsValue]="brandSettingValue"
    [separateLogicForMobileAndDesktop]="propIsSet"
    [isAppliedToBoth]="isAppliedToBoth"
    [isAppliedToMobile]="isAppliedToMobileOnly"
    [isAppliedToDesktop]="isAppliedToDesktopOnly"
    [canApplyBrandToMobile]="canApplyBrandToMobile"
    (apply)="applyBrandSettings()"></app-link-to-brand-variables>
}
